// // import { useMemo, useState } from "react";
// // import { ComposableMap, Geographies, Geography } from "react-simple-maps";
// // import { Mail, MapPin, Phone, User, Globe2, Clock, ArrowUpRight } from "lucide-react";
// // import "./international.css";

// // // ---------------------------------------------------------------------------
// // // Data
// // // ---------------------------------------------------------------------------

// // const WORLD_WIDTH = 820;
// // const WORLD_HEIGHT = 520;
// // const WORLD_SCALE = 125; // Adjusted for equirectangular

// // // Topojson served from CDN — react-simple-maps fetches + parses it for us,
// // // so no `world-atlas` / `topojson-client` packages are required.
// // const WORLD_GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

// // /**
// //  * Equirectangular projection, written out longhand so this file has ZERO
// //  * dependencies beyond react-simple-maps + lucide-react.
// //  *
// //  * It is the exact same formula d3-geo uses internally, which is what
// //  * <ComposableMap projection="geoEquirectangular" /> renders with — so our
// //  * markers land pixel-perfect on top of the drawn countries.
// //  *
// //  *   x = translateX + scale * (longitude in radians)
// //  *   y = translateY - scale * (latitude in radians)
// //  */
// // const DEG_TO_RAD = Math.PI / 180;

// // function projectEquirectangular([lon, lat]) {
// //   const x = WORLD_WIDTH / 2 + WORLD_SCALE * (lon * DEG_TO_RAD);
// //   const y = WORLD_HEIGHT / 2 - WORLD_SCALE * (lat * DEG_TO_RAD);
// //   return [x, y];
// // }

// // function toMarkerPercent([lon, lat]) {
// //   const [x, y] = projectEquirectangular([lon, lat]);
// //   return {
// //     x: `${(x / WORLD_WIDTH) * 100}%`,
// //     y: `${(y / WORLD_HEIGHT) * 100}%`,
// //     px: x,
// //     py: y,
// //   };
// // }

// // // Good spacing between European cities
// // const internationalOffices = [
// //   {
// //     key: "usa",
// //     country: "USA",
// //     region: "North America",
// //     timezone: "GMT −5:00",
// //     contact: "",
// //     address: "",
// //     phone: "",
// //     email: "",
// //     coordinates: [-74.006, 40.7128],
// //   },
// //   {
// //     key: "amsterdam",
// //     country: "Amsterdam",
// //     region: "Western Europe",
// //     timezone: "GMT +1:00",
// //     contact: "",
// //     address: "",
// //     phone: "",
// //     email: "",
// //     coordinates: [3.5, 53.1],
// //   },
// //   {
// //     key: "germany",
// //     country: "Germany",
// //     region: "Central Europe",
// //     timezone: "GMT +1:00",
// //     contact: "",
// //     address: "",
// //     phone: "",
// //     email: "",
// //     coordinates: [15.2, 51.7],
// //   },
// //   {
// //     key: "japan",
// //     country: "Japan",
// //     region: "East Asia",
// //     timezone: "GMT +9:00",
// //     contact: "",
// //     address: "",
// //     phone: "",
// //     email: "",
// //     coordinates: [139.6503, 35.6762],
// //   },
// //   {
// //     key: "london",
// //     country: "London (UK)",
// //     region: "United Kingdom",
// //     timezone: "GMT +0:00",
// //     contact: "",
// //     address: "",
// //     phone: "",
// //     email: "",
// //     coordinates: [-1.4, 50.6],
// //   },
// // ].map((office) => ({ ...office, marker: toMarkerPercent(office.coordinates) }));

// // // India HQ — origin of every connection arc
// // const HQ = { name: "New Delhi (HQ)", coordinates: [77.209, 28.6139] };
// // const HQ_MARKER = toMarkerPercent(HQ.coordinates);

// // function mapSearchUrl(address) {
// //   return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
// // }

// // /** Curved connector between HQ and an office, in projected screen space. */
// // function arcPath(from, to) {
// //   const mx = (from.px + to.px) / 2;
// //   const my = (from.py + to.py) / 2;
// //   const dx = to.px - from.px;
// //   const dy = to.py - from.py;
// //   const dist = Math.sqrt(dx * dx + dy * dy);
// //   // perpendicular lift so the arc bows upward
// //   const lift = Math.min(dist * 0.28, 110);
// //   const nx = -dy / (dist || 1);
// //   const ny = dx / (dist || 1);
// //   const cx = mx + nx * lift;
// //   const cy = my + ny * lift - Math.abs(dy) * 0.05;
// //   return `M ${from.px} ${from.py} Q ${cx} ${cy} ${to.px} ${to.py}`;
// // }

// // // ---------------------------------------------------------------------------
// // // WorldMap - Equirectangular Projection
// // // ---------------------------------------------------------------------------

// // function WorldMap({ selected, onSelect }) {
// //   const [hovered, setHovered] = useState(null);

// //   return (
// //     <div
// //       className="group/map relative w-full overflow-hidden rounded-[24px] border border-[#FEF7F4] bg-gradient-to-br from-white via-[#FEF7F4] to-[#FAF7F2] shadow-[0_24px_60px_rgba(116,35,0,0.14)]"
// //       style={{ aspectRatio: `${WORLD_WIDTH} / ${WORLD_HEIGHT}` }}
// //     >
// //       {/* ambient glow blobs */}
// //       <div className="pointer-events-none absolute -left-16 -top-16 h-64 w-64 rounded-full bg-[#F59C00]/15 blur-3xl" />
// //       <div className="pointer-events-none absolute -bottom-20 -right-10 h-72 w-72 rounded-full bg-[#DA2128]/10 blur-3xl" />

// //       {/* shimmer skeleton — sits underneath the SVG while the topojson loads */}
// //       <div className="pointer-events-none absolute inset-0 z-0 assoc-shimmer" />

// //       <ComposableMap
// //         projection="geoEquirectangular"
// //         projectionConfig={{ scale: WORLD_SCALE }}
// //         width={WORLD_WIDTH}
// //         height={WORLD_HEIGHT}
// //         style={{ width: "100%", height: "100%", display: "block", position: "relative", zIndex: 10 }}
// //       >
// //         <defs>
// //           <linearGradient id="arcStroke" x1="0" y1="0" x2="1" y2="0">
// //             <stop offset="0%" stopColor="#DA2128" stopOpacity="0.15" />
// //             <stop offset="50%" stopColor="#DB6400" stopOpacity="0.9" />
// //             <stop offset="100%" stopColor="#F59C00" stopOpacity="0.35" />
// //           </linearGradient>
// //           <filter id="arcGlow" x="-50%" y="-50%" width="200%" height="200%">
// //             <feGaussianBlur stdDeviation="2.4" result="b" />
// //             <feMerge>
// //               <feMergeNode in="b" />
// //               <feMergeNode in="SourceGraphic" />
// //             </feMerge>
// //           </filter>
// //         </defs>

// //         <Geographies geography={WORLD_GEO_URL}>
// //           {({ geographies }) =>
// //             geographies.map((geo) => (
// //               <Geography
// //                 key={geo.rsmKey}
// //                 geography={geo}
// //                 tabIndex={-1}
// //                 style={{
// //                   default: { fill: "#d6d6d8", stroke: "#ffffff", strokeWidth: 0.6, outline: "none", transition: "fill 260ms ease" },
// //                   hover: { fill: "#c2c2c6", stroke: "#ffffff", strokeWidth: 0.6, outline: "none" },
// //                   pressed: { fill: "#bdbdc2", stroke: "#ffffff", strokeWidth: 0.6, outline: "none" },
// //                 }}
// //               />
// //             ))
// //           }
// //         </Geographies>

// //         {/* animated connection arcs from HQ */}
// //         <g>
// //           {internationalOffices.map((office, i) => {
// //             const isActive = office.key === selected.key;
// //             return (
// //               <path
// //                 key={`arc-${office.key}`}
// //                 d={arcPath(HQ_MARKER, office.marker)}
// //                 fill="none"
// //                 stroke={isActive ? "url(#arcStroke)" : "#DB6400"}
// //                 strokeWidth={isActive ? 2.1 : 1}
// //                 strokeOpacity={isActive ? 1 : 0.28}
// //                 strokeLinecap="round"
// //                 strokeDasharray="7 9"
// //                 filter={isActive ? "url(#arcGlow)" : undefined}
// //                 className="assoc-arc"
// //                 style={{ animationDelay: `${i * 0.35}s` }}
// //               />
// //             );
// //           })}
// //         </g>

// //         {/* HQ star marker */}
// //         <g transform={`translate(${HQ_MARKER.px}, ${HQ_MARKER.py})`}>
// //           <circle r="9" fill="#DA2128" opacity="0.16" className="assoc-hq-halo" />
// //           <circle r="4.6" fill="#DA2128" stroke="#fff" strokeWidth="1.6" />
// //         </g>
// //       </ComposableMap>

// //       {/* office markers */}
// //       {internationalOffices.map((office, i) => {
// //         const isActive = office.key === selected.key;
// //         const isHover = hovered === office.key;

// //         return (
// //           <button
// //             key={office.key}
// //             type="button"
// //             onClick={() => onSelect(office)}
// //             onMouseEnter={() => setHovered(office.key)}
// //             onMouseLeave={() => setHovered(null)}
// //             aria-label={`Show ${office.country} office`}
// //             className="absolute z-20 flex h-9 w-9 -translate-x-1/2 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full transition-all duration-300 hover:scale-125 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#DA2128] focus-visible:ring-offset-2"
// //             style={{ left: office.marker.x, top: office.marker.y }}
// //           >
// //             {/* ripple rings */}
// //             <span
// //               className={`absolute rounded-full ${isActive ? "h-9 w-9 bg-[#DA2128]/25" : "h-6 w-6 bg-[#F59C00]/20"} assoc-ripple`}
// //               style={{ animationDelay: `${i * 0.25}s` }}
// //             />
// //             {isActive && <span className="absolute h-7 w-7 animate-ping rounded-full bg-[#F59C00]/40" />}

// //             {/* gradient location dot */}
// //             <span
// //               className={`relative rounded-full border-[2px] border-white shadow-[0_6px_14px_rgba(119,61,0,0.35)] transition-all duration-300 ${
// //                 isActive ? "h-[17px] w-[17px]" : isHover ? "h-[15px] w-[15px]" : "h-[13px] w-[13px]"
// //               }`}
// //               style={{
// //                 backgroundImage:
// //                   "radial-gradient(circle at 32% 28%, #FFD277 0%, #F59C00 38%, #DB6400 66%, #DA2128 100%)",
// //               }}
// //             >
// //               <span className="absolute left-1/2 top-[18%] h-[3px] w-[4px] -translate-x-1/2 rounded-full bg-white/70" />
// //             </span>
// //           </button>
// //         );
// //       })}

// //       {/* HQ chip */}
// //       <div
// //         className="pointer-events-none absolute z-20 whitespace-nowrap rounded-[5px] border border-white/40 bg-[#DA2128] px-[8px] py-[3px] text-[9px] font-extrabold uppercase tracking-wide text-white shadow-[0_8px_16px_rgba(126,0,0,0.22)]"
// //         style={{ left: HQ_MARKER.x, top: HQ_MARKER.y, transform: "translate(-50%, 14px)" }}
// //       >
// //         India HQ
// //       </div>

// //       {/* selected label chip */}
// //       <div
// //         className="pointer-events-none absolute z-30 whitespace-nowrap rounded-[6px] bg-gradient-to-r from-[#F59C00] to-[#DB6400] px-[11px] py-[5px] text-[11px] font-extrabold uppercase leading-none tracking-wide text-white shadow-[0_10px_20px_rgba(126,56,0,0.28)] transition-all duration-500 ease-out"
// //         style={{
// //           left: selected.marker.x,
// //           top: selected.marker.y,
// //           transform: "translate(-50%, calc(-100% - 16px))",
// //         }}
// //       >
// //         {selected.country.toUpperCase()}
// //         <span className="absolute left-1/2 top-full h-0 w-0 -translate-x-1/2 border-x-[5px] border-t-[5px] border-x-transparent border-t-[#DB6400]" />
// //       </div>

// //       {/* legend */}
// //       <div className="pointer-events-none absolute bottom-3 left-4 z-30 flex items-center gap-4 rounded-full bg-white/80 px-3.5 py-1.5 text-[10px] font-semibold text-[#6a6a7a] shadow-sm backdrop-blur-sm">
// //         <span className="flex items-center gap-1.5"><span className="h-2 w-2 rounded-full bg-[#DA2128]" /> Headquarters</span>
// //         <span className="flex items-center gap-1.5"><span className="h-2 w-2 rounded-full bg-[#F59C00]" /> Overseas Office</span>
// //       </div>
// //     </div>
// //   );
// // }

// // // ---------------------------------------------------------------------------
// // // InternationalOfficeCard with Location Buttons
// // // ---------------------------------------------------------------------------

// // function InternationalOfficeCard({ office, offices, onSelect }) {
// //   const rows = [
// //     { icon: User, label: "Contact Person", value: office.contact, href: null },
// //     {
// //       icon: MapPin,
// //       label: "Address",
// //       value: office.address,
// //       href: office.address ? mapSearchUrl(office.address) : null,
// //       external: true,
// //     },
// //     {
// //       icon: Phone,
// //       label: "Phone",
// //       value: office.phone,
// //       href: office.phone ? `tel:${office.phone.replace(/[^0-9+]/g, "")}` : null,
// //     },
// //     { icon: Mail, label: "Email", value: office.email, href: office.email ? `mailto:${office.email}` : null },
// //   ];

// //   return (
// //     <div className="relative flex w-full flex-col overflow-hidden rounded-[24px] bg-gradient-to-br from-[#fb9a08] via-[#e97900] to-[#cb4a00] p-6 text-white shadow-[0_24px_60px_rgba(116,35,0,0.22)]">
// //       <div className="pointer-events-none absolute -right-12 -top-12 h-44 w-44 rounded-full bg-white/10 blur-2xl" />
// //       <div className="pointer-events-none absolute -bottom-14 -left-10 h-40 w-40 rounded-full bg-[#DA2128]/25 blur-2xl" />

// //       {/* Location Buttons */}
// //       <div className="relative z-10 mb-5 flex flex-wrap gap-1.5">
// //         {offices.map((loc) => (
// //           <button
// //             key={loc.key}
// //             onClick={() => onSelect(loc)}
// //             className={`rounded-full px-3 py-1.5 text-[11px] font-bold transition-all duration-300 ${
// //               loc.key === office.key
// //                 ? "scale-105 bg-white text-[#c67800] shadow-md"
// //                 : "bg-white/20 text-white hover:bg-white/35"
// //             }`}
// //           >
// //             {loc.country}
// //           </button>
// //         ))}
// //       </div>

// //       {/* Header */}
// //       <div className="relative z-10 mb-5 border-b border-white/25 pb-4">
// //         <div className="mb-1 flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.16em] text-white/70">
// //           <Globe2 className="h-3 w-3" /> {office.region}
// //         </div>
// //         <h4 className="font-['Cormorant_Garamond'] text-3xl font-semibold leading-none tracking-tight">
// //           {office.country}
// //         </h4>
// //         <div className="mt-2 inline-flex items-center gap-1.5 rounded-full bg-white/20 px-2.5 py-1 text-[10px] font-semibold">
// //           <Clock className="h-3 w-3" /> {office.timezone}
// //         </div>
// //       </div>

// //       {/* Details */}
// //       <div className="relative z-10 space-y-3 text-[13px] leading-[1.4]">
// //         {rows.map(({ icon: Icon, label, value, href, external }) => {
// //           const content = (
// //             <>
// //               <span className="mt-[1px] flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg bg-white/20 transition-colors group-hover:bg-white/35">
// //                 <Icon className="h-3.5 w-3.5 stroke-[2.3]" />
// //               </span>
// //               <span className="min-w-0 flex-1">
// //                 <span className="block text-[9.5px] font-bold uppercase tracking-wider text-white/60">{label}</span>
// //                 <span className="block break-words group-hover:underline">{value || "—"}</span>
// //               </span>
// //               {href && <ArrowUpRight className="mt-1 h-3.5 w-3.5 flex-shrink-0 opacity-70" />}
// //             </>
// //           );

// //           return href ? (
// //             <a
// //               key={label}
// //               href={href}
// //               target={external ? "_blank" : undefined}
// //               rel={external ? "noreferrer" : undefined}
// //               className="group flex gap-2.5 rounded-lg outline-none transition-colors hover:text-white focus-visible:ring-2 focus-visible:ring-white/80"
// //             >
// //               {content}
// //             </a>
// //           ) : (
// //             <div key={label} className="group flex gap-2.5">
// //               {content}
// //             </div>
// //           );
// //         })}
// //       </div>

// //       <a
// //         href="#"
// //         className="relative z-10 mt-6 block rounded-full bg-white py-3 text-center text-[13px] font-bold text-[#c64a00] shadow-lg transition-transform hover:scale-[1.02]"
// //       >
// //         Connect with this Office →
// //       </a>
// //     </div>
// //   );
// // }

// // // ---------------------------------------------------------------------------
// // // Main Component
// // // ---------------------------------------------------------------------------

// // export default function GlobalPresence() {
// //   const [selectedKey, setSelectedKey] = useState("usa");

// //   const selectedOffice = useMemo(
// //     () => internationalOffices.find((office) => office.key === selectedKey) || internationalOffices[0],
// //     [selectedKey]
// //   );

// //   const handleSelect = (office) => setSelectedKey(office.key);

// //   return (
// //     <div className="rounded-[28px] border border-[#FEF7F4] bg-white p-6 shadow-xl shadow-black/[0.04] md:p-10">
// //       <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
// //         <div>
// //           <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-[#DA2128]/10 px-3.5 py-1.5 text-xs font-bold uppercase tracking-wider text-[#DA2128]">
// //             <MapPin className="h-3.5 w-3.5" /> Global Footprint
// //           </div>
// //           <h3 className="font-['Cormorant_Garamond'] text-4xl font-semibold tracking-tight text-[#1a1a2e] md:text-5xl">
// //             ASSOCHAM <span className="italic font-normal text-[#DB6400]">International Offices</span>
// //           </h3>
// //           <p className="mt-3 max-w-xl text-[#6a6a7a]">
// //             Select a location on the map to view office details, contacts, and regional coverage.
// //           </p>
// //         </div>
// //         <div className="flex gap-6">
// //           <div>
// //             <div className="font-['Outfit'] text-3xl font-bold text-[#DA2128]">05</div>
// //             <div className="text-xs font-semibold uppercase tracking-wide text-[#9a9aab]">Overseas Offices</div>
// //           </div>
// //           <div>
// //             <div className="font-['Outfit'] text-3xl font-bold text-[#DB6400]">04</div>
// //             <div className="text-xs font-semibold uppercase tracking-wide text-[#9a9aab]">Continents</div>
// //           </div>
// //         </div>
// //       </div>

// //       <div className="flex flex-col items-stretch gap-6 lg:flex-row lg:items-start">
// //         <div className="min-w-0 flex-1">
// //           <WorldMap selected={selectedOffice} onSelect={handleSelect} />
// //         </div>
// //         <div className="w-full lg:w-[320px] lg:flex-shrink-0">
// //           <InternationalOfficeCard office={selectedOffice} offices={internationalOffices} onSelect={handleSelect} />
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }






// // new code 




// import { useMemo, useState } from "react";
// import { ComposableMap, Geographies, Geography } from "react-simple-maps";
// import {
//   Mail,
//   MapPin,
//   Phone,
//   Building2,
//   Globe2,
//   Clock,
//   ArrowUpRight,
//   Handshake,
// } from "lucide-react";
// import "./international.css";

// // ---------------------------------------------------------------------------
// // Map constants
// // ---------------------------------------------------------------------------

// const WORLD_WIDTH = 820;
// const WORLD_HEIGHT = 520;
// const WORLD_SCALE = 125; // Adjusted for equirectangular

// // Topojson served from CDN — react-simple-maps fetches + parses it for us,
// // so no `world-atlas` / `topojson-client` packages are required.
// const WORLD_GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

// /**
//  * Equirectangular projection, written out longhand so this file has ZERO
//  * dependencies beyond react-simple-maps + lucide-react.
//  *
//  *   x = translateX + scale * (longitude in radians)
//  *   y = translateY - scale * (latitude in radians)
//  */
// const DEG_TO_RAD = Math.PI / 180;

// function projectEquirectangular([lon, lat]) {
//   const x = WORLD_WIDTH / 2 + WORLD_SCALE * (lon * DEG_TO_RAD);
//   const y = WORLD_HEIGHT / 2 - WORLD_SCALE * (lat * DEG_TO_RAD);
//   return [x, y];
// }

// function toMarkerPercent([lon, lat]) {
//   const [x, y] = projectEquirectangular([lon, lat]);
//   return {
//     x: `${(x / WORLD_WIDTH) * 100}%`,
//     y: `${(y / WORLD_HEIGHT) * 100}%`,
//     px: x,
//     py: y,
//   };
// }

// // ---------------------------------------------------------------------------
// // Data — International Partner Chambers / Associations
// // ---------------------------------------------------------------------------

// const REGION_ORDER = [
//   "Asia",
//   "Americas",
//   "Europe",
//   "Russia",
//   "CIS",
//   "East Asia",
//   "Middle East",
//   "Africa",
//   "Southeast Asia",
//   "Oceania",
// ];

// const RAW_PARTNERS = [
//   // ------------------------------- ASIA ------------------------------------
//   {
//     key: "lk-ceylon",
//     name: "The Ceylon Chamber",
//     short: "Ceylon Chamber",
//     region: "Asia",
//     country: "Sri Lanka",
//     city: "Colombo",
//     timezone: "GMT +5:30",
//     coordinates: [79.8612, 6.9271],
//   },
//   {
//     key: "lk-national",
//     name: "The National Chamber of Commerce of Sri Lanka",
//     short: "National Chamber (SL)",
//     region: "Asia",
//     country: "Sri Lanka",
//     city: "Colombo",
//     timezone: "GMT +5:30",
//     coordinates: [81.3, 7.9],
//   },
//   {
//     key: "lk-federation",
//     name: "Federation of Chambers of Commerce and Industry of Sri Lanka",
//     short: "FCCISL",
//     region: "Asia",
//     country: "Sri Lanka",
//     city: "Colombo",
//     timezone: "GMT +5:30",
//     coordinates: [78.6, 5.6],
//   },
//   {
//     key: "np-ncc",
//     name: "Nepal Chamber of Commerce",
//     short: "Nepal Chamber",
//     region: "Asia",
//     country: "Nepal",
//     city: "Kathmandu",
//     timezone: "GMT +5:45",
//     coordinates: [85.324, 27.7172],
//   },
//   {
//     key: "af-acci",
//     name: "Afghanistan Chamber of Commerce and Industries",
//     short: "ACCI Afghanistan",
//     region: "Asia",
//     country: "Afghanistan",
//     city: "Kabul",
//     timezone: "GMT +4:30",
//     coordinates: [69.2075, 34.5553],
//   },
//   {
//     key: "bd-dcci",
//     name: "The Dhaka Chamber of Commerce & Industry",
//     short: "DCCI Dhaka",
//     region: "Asia",
//     country: "Bangladesh",
//     city: "Dhaka",
//     timezone: "GMT +6:00",
//     coordinates: [90.4125, 23.8103],
//   },

//   // ----------------------------- AMERICAS ----------------------------------
//   {
//     key: "ca-surrey",
//     name: "Surrey Board of Trade",
//     short: "Surrey Board of Trade",
//     region: "Americas",
//     country: "Canada",
//     city: "Surrey, BC",
//     timezone: "GMT −8:00",
//     coordinates: [-122.849, 49.1913],
//   },
//   {
//     key: "us-ausib",
//     name: "Alliance for U.S. India Business (AUSIB)",
//     short: "AUSIB",
//     region: "Americas",
//     country: "USA",
//     city: "Washington, D.C.",
//     timezone: "GMT −5:00",
//     coordinates: [-77.0369, 38.9072],
//   },
//   {
//     key: "ca-winnipeg",
//     name: "The Winnipeg Chamber of Commerce",
//     short: "Winnipeg Chamber",
//     region: "Americas",
//     country: "Canada",
//     city: "Winnipeg, MB",
//     timezone: "GMT −6:00",
//     coordinates: [-97.1384, 49.8951],
//   },
//   {
//     key: "mx-imbc",
//     name: "India-Mexico Business Chamber (IMBC)",
//     short: "IMBC Mexico",
//     region: "Americas",
//     country: "Mexico",
//     city: "Mexico City",
//     timezone: "GMT −6:00",
//     coordinates: [-99.1332, 19.4326],
//   },
//   {
//     key: "ar-cfi",
//     name: "Federal Council of Investments (CFI)",
//     short: "CFI Argentina",
//     region: "Americas",
//     country: "Argentina",
//     city: "Buenos Aires",
//     timezone: "GMT −3:00",
//     coordinates: [-58.3816, -34.6037],
//   },
//   {
//     key: "us-illinois",
//     name: "Illinois Global Partnership Inc.",
//     short: "Illinois Global",
//     region: "Americas",
//     country: "USA",
//     city: "Chicago, IL",
//     timezone: "GMT −6:00",
//     coordinates: [-87.6298, 41.8781],
//   },
//   {
//     key: "us-usiacc",
//     name: "U.S. Indian American Chamber of Commerce (USIACC)",
//     short: "USIACC",
//     region: "Americas",
//     country: "USA",
//     city: "Atlanta, GA",
//     timezone: "GMT −5:00",
//     coordinates: [-84.388, 33.749],
//   },

//   // ------------------------------ EUROPE -----------------------------------
//   {
//     key: "si-ccis",
//     name: "Chamber of Commerce and Industry of Slovenia (CCIS)",
//     short: "CCIS Slovenia",
//     region: "Europe",
//     country: "Slovenia",
//     city: "Ljubljana",
//     timezone: "GMT +1:00",
//     coordinates: [14.5058, 46.0569],
//   },
//   {
//     key: "is-si",
//     name: "The Federation of Icelandic Industries",
//     short: "Icelandic Industries",
//     region: "Europe",
//     country: "Iceland",
//     city: "Reykjavík",
//     timezone: "GMT +0:00",
//     coordinates: [-21.9426, 64.1466],
//   },
//   {
//     key: "lv-lcci",
//     name: "Latvian Chamber of Commerce and Industry (LCCI)",
//     short: "LCCI Latvia",
//     region: "Europe",
//     country: "Latvia",
//     city: "Riga",
//     timezone: "GMT +2:00",
//     coordinates: [24.1052, 56.9496],
//   },
//   {
//     key: "lv-lddk",
//     name: "Employers' Confederation of Latvia (LDDK)",
//     short: "LDDK Latvia",
//     region: "Europe",
//     country: "Latvia",
//     city: "Riga",
//     timezone: "GMT +2:00",
//     coordinates: [25.6, 58.1],
//   },
//   {
//     key: "hr-cce",
//     name: "Croatian Chamber of Economy (CCE)",
//     short: "CCE Croatia",
//     region: "Europe",
//     country: "Croatia",
//     city: "Zagreb",
//     timezone: "GMT +1:00",
//     coordinates: [15.9819, 45.815],
//   },
//   {
//     key: "ro-prahova",
//     name: "Chamber of Commerce and Industry Prahova",
//     short: "CCI Prahova",
//     region: "Europe",
//     country: "Romania",
//     city: "Ploiești",
//     timezone: "GMT +2:00",
//     coordinates: [26.0225, 45.6],
//   },
//   {
//     key: "ro-bucharest",
//     name: "Bucharest Chamber of Commerce and Industry",
//     short: "Bucharest CCI",
//     region: "Europe",
//     country: "Romania",
//     city: "Bucharest",
//     timezone: "GMT +2:00",
//     coordinates: [26.1025, 44.4268],
//   },
//   {
//     key: "mt-chamber",
//     name: "The Malta Chamber of Commerce, Enterprise and Industry",
//     short: "Malta Chamber",
//     region: "Europe",
//     country: "Malta",
//     city: "Valletta",
//     timezone: "GMT +1:00",
//     coordinates: [14.5146, 35.8989],
//   },
//   {
//     key: "es-ceoe",
//     name: "Spanish Confederation of Business Organisations (CEOE)",
//     short: "CEOE Spain",
//     region: "Europe",
//     country: "Spain",
//     city: "Madrid",
//     timezone: "GMT +1:00",
//     coordinates: [-3.7038, 40.4168],
//   },
//   {
//     key: "uk-lcci",
//     name: "London Chamber of Commerce & Industry (LCCI)",
//     short: "London CCI",
//     region: "Europe",
//     country: "United Kingdom",
//     city: "London",
//     timezone: "GMT +0:00",
//     coordinates: [-1.6, 51.9],
//   },
//   {
//     key: "bg-ibbc",
//     name: "Indian Bulgarian Business Chamber",
//     short: "Indo-Bulgarian Chamber",
//     region: "Europe",
//     country: "Bulgaria",
//     city: "Sofia",
//     timezone: "GMT +2:00",
//     coordinates: [23.3219, 42.6977],
//   },
//   {
//     key: "fr-pau",
//     name: "Chamber of Commerce and Industry, Pau Béarn",
//     short: "CCI Pau Béarn",
//     region: "Europe",
//     country: "France",
//     city: "Pau",
//     timezone: "GMT +1:00",
//     coordinates: [-0.3707, 43.2951],
//   },
//   {
//     key: "eu-eicc",
//     name: "Europe India Chamber of Commerce (EICC)",
//     short: "EICC",
//     region: "Europe",
//     country: "Belgium",
//     city: "Brussels",
//     timezone: "GMT +1:00",
//     coordinates: [4.3517, 50.8503],
//   },

//   // ------------------------------ RUSSIA -----------------------------------
//   {
//     key: "ru-business",
//     name: "Business Russia",
//     short: "Business Russia",
//     region: "Russia",
//     country: "Russia",
//     city: "Moscow",
//     timezone: "GMT +3:00",
//     coordinates: [37.6173, 55.7558],
//   },
//   {
//     key: "ru-roscongress",
//     name: "Roscongress Foundation",
//     short: "Roscongress",
//     region: "Russia",
//     country: "Russia",
//     city: "Moscow",
//     timezone: "GMT +3:00",
//     coordinates: [39.6, 56.9],
//   },
//   {
//     key: "ru-opora",
//     name:
//       "Saint-Petersburg Department of the All-Russian NGO of Small and Medium Business — OPORA RUSSIA",
//     short: "OPORA Russia (SPb)",
//     region: "Russia",
//     country: "Russia",
//     city: "Saint Petersburg",
//     timezone: "GMT +3:00",
//     coordinates: [30.3351, 59.9343],
//   },
//   {
//     key: "ru-astrakhan",
//     name: "The Astrakhan Chamber of Commerce and Industry",
//     short: "Astrakhan CCI",
//     region: "Russia",
//     country: "Russia",
//     city: "Astrakhan",
//     timezone: "GMT +4:00",
//     coordinates: [48.0408, 46.3497],
//   },
//   {
//     key: "ru-ccirf",
//     name: "Chamber of Commerce and Industry of the Russian Federation",
//     short: "CCI Russian Federation",
//     region: "Russia",
//     country: "Russia",
//     city: "Moscow",
//     timezone: "GMT +3:00",
//     coordinates: [35.4, 54.4],
//   },

//   // -------------------------------- CIS ------------------------------------
//   {
//     key: "uz-cci",
//     name: "Chamber of Commerce and Industry of Uzbekistan",
//     short: "CCI Uzbekistan",
//     region: "CIS",
//     country: "Uzbekistan",
//     city: "Tashkent",
//     timezone: "GMT +5:00",
//     coordinates: [69.2401, 41.2995],
//   },
//   {
//     key: "kz-cci",
//     name: "The Chamber of Commerce & Industry of Kazakhstan",
//     short: "CCI Kazakhstan",
//     region: "CIS",
//     country: "Kazakhstan",
//     city: "Astana",
//     timezone: "GMT +5:00",
//     coordinates: [71.4306, 51.1605],
//   },
//   {
//     key: "ua-icc",
//     name: "International Chamber of Commerce (ICC Ukraine)",
//     short: "ICC Ukraine",
//     region: "CIS",
//     country: "Ukraine",
//     city: "Kyiv",
//     timezone: "GMT +2:00",
//     coordinates: [30.5234, 50.4501],
//   },

//   // ----------------------------- EAST ASIA ---------------------------------
//   {
//     key: "jp-jetro",
//     name: "Japan External Trade Organisation (JETRO)",
//     short: "JETRO",
//     region: "East Asia",
//     country: "Japan",
//     city: "Tokyo",
//     timezone: "GMT +9:00",
//     coordinates: [139.6503, 35.6762],
//   },
//   {
//     key: "jp-iccj",
//     name: "The Indian Chamber of Commerce — Japan (ICCJ)",
//     short: "ICCJ Osaka",
//     region: "East Asia",
//     country: "Japan",
//     city: "Osaka",
//     timezone: "GMT +9:00",
//     coordinates: [135.5023, 33.9],
//   },
//   {
//     key: "kr-knut",
//     name: "Korea National University of Transportation",
//     short: "KNUT Korea",
//     region: "East Asia",
//     country: "South Korea",
//     city: "Chungju",
//     timezone: "GMT +9:00",
//     coordinates: [127.926, 37.6],
//   },
//   {
//     key: "kr-cheongju",
//     name: "Cheongju Chamber of Commerce and Industry",
//     short: "Cheongju CCI",
//     region: "East Asia",
//     country: "South Korea",
//     city: "Cheongju",
//     timezone: "GMT +9:00",
//     coordinates: [127.489, 36.6424],
//   },
//   {
//     key: "kr-kctech",
//     name: "Korea Institute of Carbon Convergence Technology (KCTECH)",
//     short: "KCTECH",
//     region: "East Asia",
//     country: "South Korea",
//     city: "Jeonju",
//     timezone: "GMT +9:00",
//     coordinates: [126.9, 35.4],
//   },
//   {
//     key: "cn-ccpit",
//     name: "China Council for the Promotion of International Trade (CCPIT)",
//     short: "CCPIT China",
//     region: "East Asia",
//     country: "China",
//     city: "Beijing",
//     timezone: "GMT +8:00",
//     coordinates: [116.4074, 39.9042],
//   },
//   {
//     key: "mn-mncci",
//     name: "Mongolian National Chamber of Commerce & Industry",
//     short: "MNCCI Mongolia",
//     region: "East Asia",
//     country: "Mongolia",
//     city: "Ulaanbaatar",
//     timezone: "GMT +8:00",
//     coordinates: [106.9057, 47.8864],
//   },

//   // ---------------------------- MIDDLE EAST --------------------------------
//   {
//     key: "bh-bcci",
//     name: "Bahrain Chamber of Commerce & Industry",
//     short: "Bahrain Chamber",
//     region: "Middle East",
//     country: "Bahrain",
//     city: "Manama",
//     timezone: "GMT +3:00",
//     coordinates: [50.5875, 26.2285],
//   },
//   {
//     key: "il-iacc",
//     name: "Israel-Asia Chamber of Commerce",
//     short: "Israel-Asia Chamber",
//     region: "Middle East",
//     country: "Israel",
//     city: "Tel Aviv",
//     timezone: "GMT +2:00",
//     coordinates: [34.7818, 32.0853],
//   },
//   {
//     key: "kw-kcci",
//     name: "Kuwait Chamber of Commerce & Industry",
//     short: "Kuwait Chamber",
//     region: "Middle East",
//     country: "Kuwait",
//     city: "Kuwait City",
//     timezone: "GMT +3:00",
//     coordinates: [47.9774, 29.3759],
//   },
//   {
//     key: "ae-sharjah",
//     name: "Sharjah Chamber of Commerce & Industry",
//     short: "Sharjah Chamber",
//     region: "Middle East",
//     country: "UAE",
//     city: "Sharjah",
//     timezone: "GMT +4:00",
//     coordinates: [55.4033, 25.3463],
//   },

//   // ------------------------------- AFRICA ----------------------------------
//   {
//     key: "zm-zacci-cci",
//     name: "Zambia Chamber of Commerce & Industry",
//     short: "Zambia CCI",
//     region: "Africa",
//     country: "Zambia",
//     city: "Lusaka",
//     timezone: "GMT +2:00",
//     coordinates: [28.3228, -15.3875],
//   },
//   {
//     key: "gm-gcci",
//     name: "Gambia Chamber of Commerce and Industry (GCCI)",
//     short: "GCCI Gambia",
//     region: "Africa",
//     country: "Gambia",
//     city: "Banjul",
//     timezone: "GMT +0:00",
//     coordinates: [-16.579, 13.4549],
//   },
//   {
//     key: "sc-scci",
//     name: "Seychelles Chamber of Commerce & Industry",
//     short: "Seychelles CCI",
//     region: "Africa",
//     country: "Seychelles",
//     city: "Victoria",
//     timezone: "GMT +4:00",
//     coordinates: [55.4513, -4.6191],
//   },
//   {
//     key: "mz-cta",
//     name: "Confederation of Business Associations (CTA)",
//     short: "CTA Mozambique",
//     region: "Africa",
//     country: "Mozambique",
//     city: "Maputo",
//     timezone: "GMT +2:00",
//     coordinates: [32.5732, -25.9692],
//   },
//   {
//     key: "tz-tpsf",
//     name: "Tanzania Private Sector Foundation (TPSF)",
//     short: "TPSF Tanzania",
//     region: "Africa",
//     country: "Tanzania",
//     city: "Dar es Salaam",
//     timezone: "GMT +3:00",
//     coordinates: [39.2083, -6.7924],
//   },
//   {
//     key: "et-eccsa",
//     name: "Ethiopian Chamber of Commerce and Sectoral Associations",
//     short: "ECCSA Ethiopia",
//     region: "Africa",
//     country: "Ethiopia",
//     city: "Addis Ababa",
//     timezone: "GMT +3:00",
//     coordinates: [38.7469, 9.032],
//   },
//   {
//     key: "ma-casablanca",
//     name: "Casablanca Chamber of Commerce, Industry and Services",
//     short: "Casablanca Chamber",
//     region: "Africa",
//     country: "Morocco",
//     city: "Casablanca",
//     timezone: "GMT +1:00",
//     coordinates: [-7.5898, 33.5731],
//   },
//   {
//     key: "zm-zacci",
//     name: "Zambia Association of Chambers of Commerce and Industry (ZACCI)",
//     short: "ZACCI Zambia",
//     region: "Africa",
//     country: "Zambia",
//     city: "Lusaka",
//     timezone: "GMT +2:00",
//     coordinates: [29.9, -13.9],
//   },
//   {
//     key: "ug-uncci",
//     name: "Uganda National Chamber of Commerce and Industry (UNCCI)",
//     short: "UNCCI Uganda",
//     region: "Africa",
//     country: "Uganda",
//     city: "Kampala",
//     timezone: "GMT +3:00",
//     coordinates: [32.5825, 0.3476],
//   },
//   {
//     key: "gh-gcci",
//     name: "Ghana Chamber of Commerce & Industry",
//     short: "Ghana Chamber",
//     region: "Africa",
//     country: "Ghana",
//     city: "Accra",
//     timezone: "GMT +0:00",
//     coordinates: [-0.187, 5.6037],
//   },
//   {
//     key: "af-alm",
//     name: "African Leadership Magazine",
//     short: "African Leadership Mag.",
//     region: "Africa",
//     country: "Mauritius",
//     city: "Port Louis",
//     timezone: "GMT +4:00",
//     coordinates: [57.5522, -20.1609],
//   },

//   // --------------------------- SOUTHEAST ASIA ------------------------------
//   {
//     key: "my-maicci",
//     name: "Malaysian Associated Indian Chamber of Commerce and Industry (MAICCI)",
//     short: "MAICCI Malaysia",
//     region: "Southeast Asia",
//     country: "Malaysia",
//     city: "Kuala Lumpur",
//     timezone: "GMT +8:00",
//     coordinates: [101.6869, 3.139],
//   },
//   {
//     key: "th-tcc",
//     name: "The Thai Chamber of Commerce",
//     short: "Thai Chamber",
//     region: "Southeast Asia",
//     country: "Thailand",
//     city: "Bangkok",
//     timezone: "GMT +7:00",
//     coordinates: [100.5018, 13.7563],
//   },
//   {
//     key: "mm-umfcci",
//     name: "The Union of Myanmar Federation of Chambers of Commerce & Industry (UMFCCI)",
//     short: "UMFCCI Myanmar",
//     region: "Southeast Asia",
//     country: "Myanmar",
//     city: "Yangon",
//     timezone: "GMT +6:30",
//     coordinates: [96.1951, 16.8661],
//   },
//   {
//     key: "sg-sbf",
//     name: "Singapore Business Federation (SBF)",
//     short: "SBF Singapore",
//     region: "Southeast Asia",
//     country: "Singapore",
//     city: "Singapore",
//     timezone: "GMT +8:00",
//     coordinates: [103.8198, 1.3521],
//   },
//   {
//     key: "vn-vcci",
//     name: "Vietnam Chamber of Commerce & Industry (VCCI)",
//     short: "VCCI Vietnam",
//     region: "Southeast Asia",
//     country: "Vietnam",
//     city: "Hanoi",
//     timezone: "GMT +7:00",
//     coordinates: [105.8342, 21.0278],
//   },

//   // ------------------------------ OCEANIA ----------------------------------
//   {
//     key: "au-vecci",
//     name: "Victorian Employers Chamber of Commerce and Industry",
//     short: "VECCI Australia",
//     region: "Oceania",
//     country: "Australia",
//     city: "Melbourne",
//     timezone: "GMT +10:00",
//     coordinates: [144.9631, -37.8136],
//   },
//   {
//     key: "nz-inzbc",
//     name: "India New Zealand Business Council (INZBC)",
//     short: "INZBC",
//     region: "Oceania",
//     country: "New Zealand",
//     city: "Auckland",
//     timezone: "GMT +12:00",
//     coordinates: [174.7633, -36.8485],
//   },
// ];

// // attach projected marker positions once
// const PARTNERS = RAW_PARTNERS.map((partner) => ({
//   ...partner,
//   contact: partner.contact || "",
//   phone: partner.phone || "",
//   email: partner.email || "",
//   address: partner.address || `${partner.city}, ${partner.country}`,
//   marker: toMarkerPercent(partner.coordinates),
// }));

// const REGIONS = REGION_ORDER.filter((region) =>
//   PARTNERS.some((partner) => partner.region === region)
// );

// const REGION_COUNTS = REGIONS.reduce((acc, region) => {
//   acc[region] = PARTNERS.filter((partner) => partner.region === region).length;
//   return acc;
// }, {});

// const COUNTRY_COUNT = new Set(PARTNERS.map((partner) => partner.country)).size;

// // India HQ — origin of every connection arc
// const HQ = { name: "New Delhi (HQ)", coordinates: [77.209, 28.6139] };
// const HQ_MARKER = toMarkerPercent(HQ.coordinates);

// function mapSearchUrl(query) {
//   return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
// }

// /** Curved connector between HQ and a partner, in projected screen space. */
// function arcPath(from, to) {
//   const mx = (from.px + to.px) / 2;
//   const my = (from.py + to.py) / 2;
//   const dx = to.px - from.px;
//   const dy = to.py - from.py;
//   const dist = Math.sqrt(dx * dx + dy * dy);
//   // perpendicular lift so the arc bows outward
//   const lift = Math.min(dist * 0.28, 110);
//   const nx = -dy / (dist || 1);
//   const ny = dx / (dist || 1);
//   const cx = mx + nx * lift;
//   const cy = my + ny * lift - Math.abs(dy) * 0.05;
//   return `M ${from.px} ${from.py} Q ${cx} ${cy} ${to.px} ${to.py}`;
// }

// // ---------------------------------------------------------------------------
// // WorldMap — Equirectangular Projection
// // ---------------------------------------------------------------------------

// function WorldMap({ partners, selected, onSelect }) {
//   const [hovered, setHovered] = useState(null);

//   return (
//     <div
//       className="group/map relative w-full overflow-hidden rounded-[24px] border border-[#FEF7F4] bg-gradient-to-br from-white via-[#FEF7F4] to-[#FAF7F2] shadow-[0_24px_60px_rgba(116,35,0,0.14)]"
//       style={{ aspectRatio: `${WORLD_WIDTH} / ${WORLD_HEIGHT}` }}
//     >
//       {/* ambient glow blobs */}
//       <div className="pointer-events-none absolute -left-16 -top-16 h-64 w-64 rounded-full bg-[#F59C00]/15 blur-3xl" />
//       <div className="pointer-events-none absolute -bottom-20 -right-10 h-72 w-72 rounded-full bg-[#DA2128]/10 blur-3xl" />

//       {/* shimmer skeleton — sits underneath the SVG while the topojson loads */}
//       <div className="pointer-events-none absolute inset-0 z-0 assoc-shimmer" />

//       <ComposableMap
//         projection="geoEquirectangular"
//         projectionConfig={{ scale: WORLD_SCALE }}
//         width={WORLD_WIDTH}
//         height={WORLD_HEIGHT}
//         style={{
//           width: "100%",
//           height: "100%",
//           display: "block",
//           position: "relative",
//           zIndex: 10,
//         }}
//       >
//         <defs>
//           <linearGradient id="arcStroke" x1="0" y1="0" x2="1" y2="0">
//             <stop offset="0%" stopColor="#DA2128" stopOpacity="0.15" />
//             <stop offset="50%" stopColor="#DB6400" stopOpacity="0.9" />
//             <stop offset="100%" stopColor="#F59C00" stopOpacity="0.35" />
//           </linearGradient>
//           <filter id="arcGlow" x="-50%" y="-50%" width="200%" height="200%">
//             <feGaussianBlur stdDeviation="2.4" result="b" />
//             <feMerge>
//               <feMergeNode in="b" />
//               <feMergeNode in="SourceGraphic" />
//             </feMerge>
//           </filter>
//         </defs>

//         <Geographies geography={WORLD_GEO_URL}>
//           {({ geographies }) =>
//             geographies.map((geo) => (
//               <Geography
//                 key={geo.rsmKey}
//                 geography={geo}
//                 tabIndex={-1}
//                 style={{
//                   default: {
//                     fill: "#d6d6d8",
//                     stroke: "#ffffff",
//                     strokeWidth: 0.6,
//                     outline: "none",
//                     transition: "fill 260ms ease",
//                   },
//                   hover: {
//                     fill: "#c2c2c6",
//                     stroke: "#ffffff",
//                     strokeWidth: 0.6,
//                     outline: "none",
//                   },
//                   pressed: {
//                     fill: "#bdbdc2",
//                     stroke: "#ffffff",
//                     strokeWidth: 0.6,
//                     outline: "none",
//                   },
//                 }}
//               />
//             ))
//           }
//         </Geographies>

//         {/* animated connection arcs from HQ */}
//         <g>
//           {partners.map((partner, i) => {
//             const isActive = partner.key === selected.key;
//             return (
//               <path
//                 key={`arc-${partner.key}`}
//                 d={arcPath(HQ_MARKER, partner.marker)}
//                 fill="none"
//                 stroke={isActive ? "url(#arcStroke)" : "#DB6400"}
//                 strokeWidth={isActive ? 2.1 : 0.85}
//                 strokeOpacity={isActive ? 1 : 0.2}
//                 strokeLinecap="round"
//                 strokeDasharray="7 9"
//                 filter={isActive ? "url(#arcGlow)" : undefined}
//                 className="assoc-arc"
//                 style={{ animationDelay: `${(i % 8) * 0.35}s` }}
//               />
//             );
//           })}
//         </g>

//         {/* HQ star marker */}
//         <g transform={`translate(${HQ_MARKER.px}, ${HQ_MARKER.py})`}>
//           <circle r="9" fill="#DA2128" opacity="0.16" className="assoc-hq-halo" />
//           <circle r="4.6" fill="#DA2128" stroke="#fff" strokeWidth="1.6" />
//         </g>
//       </ComposableMap>

//       {/* partner markers */}
//       {partners.map((partner, i) => {
//         const isActive = partner.key === selected.key;
//         const isHover = hovered === partner.key;

//         return (
//           <button
//             key={partner.key}
//             type="button"
//             onClick={() => onSelect(partner)}
//             onMouseEnter={() => setHovered(partner.key)}
//             onMouseLeave={() => setHovered(null)}
//             aria-label={`Show ${partner.name}`}
//             title={`${partner.name} — ${partner.city}, ${partner.country}`}
//             className={`absolute flex h-7 w-7 -translate-x-1/2 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full transition-all duration-300 hover:scale-125 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#DA2128] focus-visible:ring-offset-2 ${
//               isActive ? "z-30" : "z-20"
//             }`}
//             style={{ left: partner.marker.x, top: partner.marker.y }}
//           >
//             {/* ripple rings */}
//             <span
//               className={`absolute rounded-full ${
//                 isActive ? "h-8 w-8 bg-[#DA2128]/25" : "h-5 w-5 bg-[#F59C00]/20"
//               } assoc-ripple`}
//               style={{ animationDelay: `${(i % 10) * 0.25}s` }}
//             />
//             {isActive && (
//               <span className="absolute h-6 w-6 animate-ping rounded-full bg-[#F59C00]/40" />
//             )}

//             {/* gradient location dot */}
//             <span
//               className={`relative rounded-full border-[2px] border-white shadow-[0_6px_14px_rgba(119,61,0,0.35)] transition-all duration-300 ${
//                 isActive
//                   ? "h-[16px] w-[16px]"
//                   : isHover
//                   ? "h-[13px] w-[13px]"
//                   : "h-[10px] w-[10px]"
//               }`}
//               style={{
//                 backgroundImage:
//                   "radial-gradient(circle at 32% 28%, #FFD277 0%, #F59C00 38%, #DB6400 66%, #DA2128 100%)",
//               }}
//             >
//               <span className="absolute left-1/2 top-[18%] h-[3px] w-[4px] -translate-x-1/2 rounded-full bg-white/70" />
//             </span>

//             {/* hover tooltip */}
//             {isHover && !isActive && (
//               <span className="pointer-events-none absolute bottom-full left-1/2 mb-1.5 -translate-x-1/2 whitespace-nowrap rounded-[5px] bg-[#1a1a2e]/90 px-2 py-1 text-[9px] font-bold uppercase tracking-wide text-white shadow-lg">
//                 {partner.short}
//               </span>
//             )}
//           </button>
//         );
//       })}

//       {/* HQ chip */}
//       <div
//         className="pointer-events-none absolute z-20 whitespace-nowrap rounded-[5px] border border-white/40 bg-[#DA2128] px-[8px] py-[3px] text-[9px] font-extrabold uppercase tracking-wide text-white shadow-[0_8px_16px_rgba(126,0,0,0.22)]"
//         style={{ left: HQ_MARKER.x, top: HQ_MARKER.y, transform: "translate(-50%, 14px)" }}
//       >
//         India HQ
//       </div>

//       {/* selected label chip */}
//       <div
//         className="pointer-events-none absolute z-40 max-w-[210px] whitespace-nowrap rounded-[6px] bg-gradient-to-r from-[#F59C00] to-[#DB6400] px-[11px] py-[5px] text-[11px] font-extrabold uppercase leading-none tracking-wide text-white shadow-[0_10px_20px_rgba(126,56,0,0.28)] transition-all duration-500 ease-out"
//         style={{
//           left: selected.marker.x,
//           top: selected.marker.y,
//           transform: "translate(-50%, calc(-100% - 16px))",
//         }}
//       >
//         {selected.short.toUpperCase()}
//         <span className="absolute left-1/2 top-full h-0 w-0 -translate-x-1/2 border-x-[5px] border-t-[5px] border-x-transparent border-t-[#DB6400]" />
//       </div>

//       {/* legend */}
//       <div className="pointer-events-none absolute bottom-3 left-4 z-30 flex items-center gap-4 rounded-full bg-white/80 px-3.5 py-1.5 text-[10px] font-semibold text-[#6a6a7a] shadow-sm backdrop-blur-sm">
//         <span className="flex items-center gap-1.5">
//           <span className="h-2 w-2 rounded-full bg-[#DA2128]" /> Headquarters
//         </span>
//         <span className="flex items-center gap-1.5">
//           <span className="h-2 w-2 rounded-full bg-[#F59C00]" /> Partner Chamber
//         </span>
//       </div>

//       {/* count chip */}
//       <div className="pointer-events-none absolute bottom-3 right-4 z-30 rounded-full bg-white/80 px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-wide text-[#DB6400] shadow-sm backdrop-blur-sm">
//         {partners.length} shown
//       </div>
//     </div>
//   );
// }

// // ---------------------------------------------------------------------------
// // RegionTabs — clickable region filter
// // ---------------------------------------------------------------------------

// function RegionTabs({ regions, active, onChange, total }) {
//   return (
//     <div className="mb-5 flex flex-wrap gap-2">
//       <button
//         type="button"
//         onClick={() => onChange("All")}
//         className={`rounded-full border px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-wide transition-all duration-300 ${
//           active === "All"
//             ? "scale-105 border-transparent bg-gradient-to-r from-[#F59C00] to-[#DB6400] text-white shadow-md"
//             : "border-[#f0e4da] bg-white text-[#6a6a7a] hover:border-[#DB6400]/40 hover:text-[#DB6400]"
//         }`}
//       >
//         All Regions
//         <span className="ml-1.5 opacity-70">{total}</span>
//       </button>

//       {regions.map((region) => (
//         <button
//           key={region}
//           type="button"
//           onClick={() => onChange(region)}
//           className={`rounded-full border px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-wide transition-all duration-300 ${
//             active === region
//               ? "scale-105 border-transparent bg-gradient-to-r from-[#F59C00] to-[#DB6400] text-white shadow-md"
//               : "border-[#f0e4da] bg-white text-[#6a6a7a] hover:border-[#DB6400]/40 hover:text-[#DB6400]"
//           }`}
//         >
//           {region}
//           <span className="ml-1.5 opacity-70">{REGION_COUNTS[region]}</span>
//         </button>
//       ))}
//     </div>
//   );
// }

// // ---------------------------------------------------------------------------
// // PartnerCard — details + clickable partner list
// // ---------------------------------------------------------------------------

// function PartnerCard({ partner, partners, onSelect }) {
//   const rows = [
//     { icon: Building2, label: "Organisation", value: partner.name, href: null },
//     {
//       icon: MapPin,
//       label: "Location",
//       value: partner.address,
//       href: mapSearchUrl(`${partner.name}, ${partner.city}, ${partner.country}`),
//       external: true,
//     },
//     { icon: Globe2, label: "Region", value: partner.region, href: null },
//     {
//       icon: Phone,
//       label: "Phone",
//       value: partner.phone,
//       href: partner.phone ? `tel:${partner.phone.replace(/[^0-9+]/g, "")}` : null,
//     },
//     {
//       icon: Mail,
//       label: "Email",
//       value: partner.email,
//       href: partner.email ? `mailto:${partner.email}` : null,
//     },
//   ];

//   return (
//     <div className="relative flex w-full flex-col overflow-hidden rounded-[24px] bg-gradient-to-br from-[#fb9a08] via-[#e97900] to-[#cb4a00] p-6 text-white shadow-[0_24px_60px_rgba(116,35,0,0.22)]">
//       <div className="pointer-events-none absolute -right-12 -top-12 h-44 w-44 rounded-full bg-white/10 blur-2xl" />
//       <div className="pointer-events-none absolute -bottom-14 -left-10 h-40 w-40 rounded-full bg-[#DA2128]/25 blur-2xl" />

//       {/* Clickable partner list (scrollable) */}
//       <div className="relative z-10 mb-5">
//         <div className="mb-2 flex items-center gap-1.5 text-[9.5px] font-bold uppercase tracking-[0.16em] text-white/70">
//           <Handshake className="h-3 w-3" /> {partners.length} Partner
//           {partners.length > 1 ? "s" : ""} in this view
//         </div>
//         <div className="assoc-scroll flex max-h-[132px] flex-wrap gap-1.5 overflow-y-auto pr-1">
//           {partners.map((item) => (
//             <button
//               key={item.key}
//               type="button"
//               onClick={() => onSelect(item)}
//               title={item.name}
//               className={`rounded-full px-3 py-1.5 text-[10.5px] font-bold transition-all duration-300 ${
//                 item.key === partner.key
//                   ? "scale-105 bg-white text-[#c67800] shadow-md"
//                   : "bg-white/20 text-white hover:bg-white/35"
//               }`}
//             >
//               {item.short}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* Header */}
//       <div className="relative z-10 mb-5 border-b border-white/25 pb-4">
//         <div className="mb-1 flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.16em] text-white/70">
//           <Globe2 className="h-3 w-3" /> {partner.region}
//         </div>
//         <h4 className="font-['Cormorant_Garamond'] text-3xl font-semibold leading-none tracking-tight">
//           {partner.country}
//         </h4>
//         <div className="mt-2 flex flex-wrap items-center gap-2">
//           <span className="inline-flex items-center gap-1.5 rounded-full bg-white/20 px-2.5 py-1 text-[10px] font-semibold">
//             <Clock className="h-3 w-3" /> {partner.timezone}
//           </span>
//           <span className="inline-flex items-center gap-1.5 rounded-full bg-white/20 px-2.5 py-1 text-[10px] font-semibold">
//             <MapPin className="h-3 w-3" /> {partner.city}
//           </span>
//         </div>
//       </div>

//       {/* Details */}
//       <div className="relative z-10 space-y-3 text-[13px] leading-[1.4]">
//         {rows.map(({ icon: Icon, label, value, href, external }) => {
//           const content = (
//             <>
//               <span className="mt-[1px] flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg bg-white/20 transition-colors group-hover:bg-white/35">
//                 <Icon className="h-3.5 w-3.5 stroke-[2.3]" />
//               </span>
//               <span className="min-w-0 flex-1">
//                 <span className="block text-[9.5px] font-bold uppercase tracking-wider text-white/60">
//                   {label}
//                 </span>
//                 <span className="block break-words group-hover:underline">{value || "—"}</span>
//               </span>
//               {href && <ArrowUpRight className="mt-1 h-3.5 w-3.5 flex-shrink-0 opacity-70" />}
//             </>
//           );

//           return href ? (
//             <a
//               key={label}
//               href={href}
//               target={external ? "_blank" : undefined}
//               rel={external ? "noreferrer" : undefined}
//               className="group flex gap-2.5 rounded-lg outline-none transition-colors hover:text-white focus-visible:ring-2 focus-visible:ring-white/80"
//             >
//               {content}
//             </a>
//           ) : (
//             <div key={label} className="group flex gap-2.5">
//               {content}
//             </div>
//           );
//         })}
//       </div>

//       <a
//         href="#"
//         className="relative z-10 mt-6 block rounded-full bg-white py-3 text-center text-[13px] font-bold text-[#c64a00] shadow-lg transition-transform hover:scale-[1.02]"
//       >
//         Connect with this Partner →
//       </a>
//     </div>
//   );
// }

// // ---------------------------------------------------------------------------
// // Main Component
// // ---------------------------------------------------------------------------

// export default function GlobalPresence() {
//   const [activeRegion, setActiveRegion] = useState("All");
//   const [selectedKey, setSelectedKey] = useState(PARTNERS[0].key);

//   const visiblePartners = useMemo(
//     () =>
//       activeRegion === "All"
//         ? PARTNERS
//         : PARTNERS.filter((partner) => partner.region === activeRegion),
//     [activeRegion]
//   );

//   const selectedPartner = useMemo(
//     () =>
//       visiblePartners.find((partner) => partner.key === selectedKey) ||
//       visiblePartners[0] ||
//       PARTNERS[0],
//     [selectedKey, visiblePartners]
//   );

//   const handleSelect = (partner) => setSelectedKey(partner.key);

//   const handleRegionChange = (region) => {
//     setActiveRegion(region);
//     const first =
//       region === "All" ? PARTNERS[0] : PARTNERS.find((partner) => partner.region === region);
//     if (first) setSelectedKey(first.key);
//   };

//   const pad = (n) => String(n).padStart(2, "0");

//   return (
//     <div className="rounded-[28px] border border-[#FEF7F4] bg-white p-6 shadow-xl shadow-black/[0.04] md:p-10">
//       <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
//         <div>
//           <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-[#DA2128]/10 px-3.5 py-1.5 text-xs font-bold uppercase tracking-wider text-[#DA2128]">
//             <MapPin className="h-3.5 w-3.5" /> Global Footprint
//           </div>
//           <h3 className="font-['Cormorant_Garamond'] text-4xl font-semibold tracking-tight text-[#1a1a2e] md:text-5xl">
//             ASSOCHAM{" "}
//             <span className="italic font-normal text-[#DB6400]">International Partners</span>
//           </h3>
//           <p className="mt-3 max-w-xl text-[#6a6a7a]">
//             Pick a region, then select a location on the map to view the partner chamber,
//             association and regional coverage.
//           </p>
//         </div>
//         <div className="flex gap-6">
//           <div>
//             <div className="font-['Outfit'] text-3xl font-bold text-[#DA2128]">
//               {pad(PARTNERS.length)}
//             </div>
//             <div className="text-xs font-semibold uppercase tracking-wide text-[#9a9aab]">
//               Partner Bodies
//             </div>
//           </div>
//           <div>
//             <div className="font-['Outfit'] text-3xl font-bold text-[#DB6400]">
//               {pad(COUNTRY_COUNT)}
//             </div>
//             <div className="text-xs font-semibold uppercase tracking-wide text-[#9a9aab]">
//               Countries
//             </div>
//           </div>
//           <div>
//             <div className="font-['Outfit'] text-3xl font-bold text-[#F59C00]">
//               {pad(REGIONS.length)}
//             </div>
//             <div className="text-xs font-semibold uppercase tracking-wide text-[#9a9aab]">
//               Regions
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* clickable region filter */}
//       <RegionTabs
//         regions={REGIONS}
//         active={activeRegion}
//         onChange={handleRegionChange}
//         total={PARTNERS.length}
//       />

//       <div className="flex flex-col items-stretch gap-6 lg:flex-row lg:items-start">
//         <div className="min-w-0 flex-1">
//           <WorldMap
//             partners={visiblePartners}
//             selected={selectedPartner}
//             onSelect={handleSelect}
//           />
//         </div>
//         <div className="w-full lg:w-[340px] lg:flex-shrink-0">
//           <PartnerCard
//             partner={selectedPartner}
//             partners={visiblePartners}
//             onSelect={handleSelect}
//           />
//         </div>
//       </div>
//     </div>
//   );
// }






// new new code 




import { useMemo, useState } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import {
  MapPin,
  Globe2,
  Building2,
  ArrowUpRight,
  HeartHandshake,
  Layers,
} from "lucide-react";
import "./international.css";

// ---------------------------------------------------------------------------
// Map constants
// ---------------------------------------------------------------------------

const WORLD_WIDTH = 820;
const WORLD_HEIGHT = 520;
const WORLD_SCALE = 125; // Adjusted for equirectangular

// Topojson served from CDN — react-simple-maps fetches + parses it for us,
// so no `world-atlas` / `topojson-client` packages are required.
const WORLD_GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

/**
 * Equirectangular projection, written out longhand so this file has ZERO
 * dependencies beyond react-simple-maps + lucide-react.
 *
 *   x = translateX + scale * (longitude in radians)
 *   y = translateY - scale * (latitude in radians)
 */
const DEG_TO_RAD = Math.PI / 180;

function projectEquirectangular([lon, lat]) {
  const x = WORLD_WIDTH / 2 + WORLD_SCALE * (lon * DEG_TO_RAD);
  const y = WORLD_HEIGHT / 2 - WORLD_SCALE * (lat * DEG_TO_RAD);
  return [x, y];
}

function toMarkerPercent([lon, lat]) {
  const [x, y] = projectEquirectangular([lon, lat]);
  return {
    x: `${(x / WORLD_WIDTH) * 100}%`,
    y: `${(y / WORLD_HEIGHT) * 100}%`,
    px: x,
    py: y,
  };
}

// ---------------------------------------------------------------------------
// Data — 10 regions, one marker each (exactly the list provided)
// ---------------------------------------------------------------------------

const RAW_REGIONS = [
  {
    key: "asia",
    region: "Asia",
    blurb: "South Asian chambers across Sri Lanka, Nepal, Afghanistan & Bangladesh.",
    coordinates: [82, 21],
    members: [
      "The Ceylon Chamber, Colombo, Sri Lanka",
      "The National Chamber of Commerce of Sri Lanka",
      "Federation of Chambers of Commerce and Industry of Sri Lanka",
      "Nepal Chamber of Commerce",
      "Afghanistan Chamber of Commerce and Industries",
      "The Dhaka Chamber of Commerce & Industry",
    ],
  },
  {
    key: "americas",
    region: "Americas",
    blurb: "Trade bodies across Canada, USA, Mexico and Argentina.",
    coordinates: [-98, 46],
    members: [
      "Surrey Board of Trade, Canada",
      "Alliance for U S India Business (AUSIB)",
      "The Winnipeg Chamber of Commerce, Canada",
      "India-Mexico Business Chamber (IMBC), Mexico",
      "Federal Council of Investments, Argentina",
      "Illinois Global Partnership Inc, USA",
      "U.S. Indian American Chamber of Commerce (USIACC)",
    ],
  },
  {
    key: "europe",
    region: "Europe",
    blurb: "Our largest cluster — 13 chambers and confederations across the EU & UK.",
    coordinates: [13, 49],
    members: [
      "Chamber of Commerce and Industry of Slovenia (CCIS)",
      "The Federation of Icelandic Industries, Iceland",
      "Latvian Chamber of Commerce and Industry (LCCI)",
      "Employers Confederation of Latvia (LDDK)",
      "Croatian Chamber of Economy (CCE)",
      "Chamber of Commerce and Industry Prahova, Romania",
      "Bucharest Chamber of Commerce and Industry, Romania",
      "The Malta Chamber of Commerce, Enterprise and Industry",
      "Spanish Confederation of Business Organisation (CEOE)",
      "London Chamber of Commerce & Industry (LCCI)",
      "Indian Bulgarian Business Chamber",
      "Chamber of Commerce and Industry, Pau Bearn (France)",
      "Europe India Chamber of Commerce (EICC)",
    ],
  },
  {
    key: "russia",
    region: "Russia",
    blurb: "Federal and regional business bodies of the Russian Federation.",
    coordinates: [55, 62],
    members: [
      "Business Russia",
      "Rosscongress Foundation",
      "Saint-Petersburg Department of the All-Russian Non-Governmental Organization of Small and Medium Business OPOROA RUSSIA",
      "The Astrakhan Chamber of Commerce and Industry, Russia",
      "Chamber of Commerce and Industry of the Russian Federation",
    ],
  },
  {
    key: "cis",
    region: "CIS",
    blurb: "Commonwealth of Independent States — Uzbekistan, Kazakhstan & Ukraine.",
    coordinates: [70, 46],
    members: [
      "Chamber of Commerce and Industry of Uzbekistan (CCE)",
      "The Chamber of Commerce & Industry of Kazakhstan",
      "International Chamber of Commerce (ICC UKRAINE)",
    ],
  },
  {
    key: "east-asia",
    region: "East Asia",
    blurb: "Japan, South Korea, China and Mongolia trade & research partners.",
    coordinates: [117, 40],
    members: [
      "Japan External Trade Organisation (JETRO)",
      "The Indian Chamber of Commerce-Japan (ICCJ), Osaka, Japan",
      "Korea National University of Transportation",
      "Cheongju Chamber of Commerce and Industry, South Korea",
      "Korea Institute of Carbon Convergence Technology (KCTECH)",
      "China Council for the Promotion of International Trade",
      "Mongolian National Chamber of Commerce & Industry",
    ],
  },
  {
    key: "middle-east",
    region: "Middle East",
    blurb: "Gulf and Levant chambers driving India–West Asia trade.",
    coordinates: [46, 26],
    members: [
      "Bahrain Chamber of Commerce & Industry",
      "Israel-Asia Chamber of Commerce",
      "Kuwait Chamber of Commerce & Industry",
      "Sharjah Chamber of Commerce & Industry",
    ],
  },
  {
    key: "africa",
    region: "Africa",
    blurb: "Eleven partners spanning East, West, Southern and North Africa.",
    coordinates: [20, 4],
    members: [
      "Zambia Chamber of Commerce & Industry",
      "Gambia Chamber of Commerce and Industry (GCCI)",
      "Seychelles Chamber of Commerce & Industry",
      "Confederation of Business Associations, Mozambique",
      "Tanzania Private Sector Foundation (TPSF)",
      "Ethiopian Chamber of Commerce and Sectoral Association",
      "Casablanca Chamber of Commerce, Industry and Services, Morocco",
      "Zambia Association of Chambers of Commerce and Industry (ZACCI)",
      "Uganda National Chamber of Commerce and Industry (UNCCI)",
      "Ghana Chamber of Commerce & Industry",
      "African Leadership Magazine",
    ],
  },
  {
    key: "southeast-asia",
    region: "Southeast Asia",
    blurb: "ASEAN chambers from Malaysia, Thailand, Myanmar, Singapore & Vietnam.",
    coordinates: [106, 4],
    members: [
      "Malaysian Associated Indian Chamber of Commerce and Industry (MAICCI)",
      "The Thai Chamber of Commerce",
      "The Union of Myanmar Federation of Chambers of Commerce & Industry (UMFCCI)",
      "Singapore Business Federation (SBF)",
      "Vietnam Chamber of Commerce & Industry",
    ],
  },
  {
    key: "oceania",
    region: "Oceania",
    blurb: "Australia and New Zealand business councils.",
    coordinates: [140, -27],
    members: [
      "Victorian Employers Chamber of Commerce and Industry, Australia",
      "India New Zealand Business Council (INZBC)",
    ],
  },
];

// attach projected marker positions once
const REGIONS = RAW_REGIONS.map((item) => ({
  ...item,
  marker: toMarkerPercent(item.coordinates),
}));

const TOTAL_PARTNERS = REGIONS.reduce((sum, item) => sum + item.members.length, 0);

// India HQ — origin of every connection arc
const HQ = { name: "New Delhi (HQ)", coordinates: [77.209, 28.6139] };
const HQ_MARKER = toMarkerPercent(HQ.coordinates);

function mapSearchUrl(query) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

/** Curved connector between HQ and a region, in projected screen space. */
function arcPath(from, to) {
  const mx = (from.px + to.px) / 2;
  const my = (from.py + to.py) / 2;
  const dx = to.px - from.px;
  const dy = to.py - from.py;
  const dist = Math.sqrt(dx * dx + dy * dy);
  // perpendicular lift so the arc bows outward
  const lift = Math.min(dist * 0.28, 110);
  const nx = -dy / (dist || 1);
  const ny = dx / (dist || 1);
  const cx = mx + nx * lift;
  const cy = my + ny * lift - Math.abs(dy) * 0.05;
  return `M ${from.px} ${from.py} Q ${cx} ${cy} ${to.px} ${to.py}`;
}

// ---------------------------------------------------------------------------
// WorldMap — Equirectangular Projection, one marker per region
// ---------------------------------------------------------------------------

function WorldMap({ selected, onSelect }) {
  const [hovered, setHovered] = useState(null);

  return (
    <div
      className="group/map relative w-full overflow-hidden rounded-[24px] border border-[#FEF7F4] bg-gradient-to-br from-white via-[#FEF7F4] to-[#FAF7F2] shadow-[0_24px_60px_rgba(116,35,0,0.14)]"
      style={{ aspectRatio: `${WORLD_WIDTH} / ${WORLD_HEIGHT}` }}
    >
      {/* ambient glow blobs */}
      <div className="pointer-events-none absolute -left-16 -top-16 h-64 w-64 rounded-full bg-[#F59C00]/15 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-20 -right-10 h-72 w-72 rounded-full bg-[#DA2128]/10 blur-3xl" />

      {/* shimmer skeleton — sits underneath the SVG while the topojson loads */}
      <div className="pointer-events-none absolute inset-0 z-0 assoc-shimmer" />

      <ComposableMap
        projection="geoEquirectangular"
        projectionConfig={{ scale: WORLD_SCALE }}
        width={WORLD_WIDTH}
        height={WORLD_HEIGHT}
        style={{
          width: "100%",
          height: "100%",
          display: "block",
          position: "relative",
          zIndex: 10,
        }}
      >
        <defs>
          <linearGradient id="arcStroke" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#DA2128" stopOpacity="0.15" />
            <stop offset="50%" stopColor="#DB6400" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#F59C00" stopOpacity="0.35" />
          </linearGradient>
          <filter id="arcGlow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="2.4" result="b" />
            <feMerge>
              <feMergeNode in="b" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        <Geographies geography={WORLD_GEO_URL}>
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                tabIndex={-1}
                style={{
                  default: {
                    fill: "#d6d6d8",
                    stroke: "#ffffff",
                    strokeWidth: 0.6,
                    outline: "none",
                    transition: "fill 260ms ease",
                  },
                  hover: {
                    fill: "#c2c2c6",
                    stroke: "#ffffff",
                    strokeWidth: 0.6,
                    outline: "none",
                  },
                  pressed: {
                    fill: "#bdbdc2",
                    stroke: "#ffffff",
                    strokeWidth: 0.6,
                    outline: "none",
                  },
                }}
              />
            ))
          }
        </Geographies>

        {/* animated connection arcs from HQ */}
        <g>
          {REGIONS.map((item, i) => {
            const isActive = item.key === selected.key;
            return (
              <path
                key={`arc-${item.key}`}
                d={arcPath(HQ_MARKER, item.marker)}
                fill="none"
                stroke={isActive ? "url(#arcStroke)" : "#DB6400"}
                strokeWidth={isActive ? 2.1 : 1}
                strokeOpacity={isActive ? 1 : 0.28}
                strokeLinecap="round"
                strokeDasharray="7 9"
                filter={isActive ? "url(#arcGlow)" : undefined}
                className="assoc-arc"
                style={{ animationDelay: `${i * 0.35}s` }}
              />
            );
          })}
        </g>

        {/* HQ star marker */}
        <g transform={`translate(${HQ_MARKER.px}, ${HQ_MARKER.py})`}>
          <circle r="9" fill="#DA2128" opacity="0.16" className="assoc-hq-halo" />
          <circle r="4.6" fill="#DA2128" stroke="#fff" strokeWidth="1.6" />
        </g>
      </ComposableMap>

      {/* region markers */}
      {REGIONS.map((item, i) => {
        const isActive = item.key === selected.key;
        const isHover = hovered === item.key;

        return (
          <button
            key={item.key}
            type="button"
            onClick={() => onSelect(item)}
            onMouseEnter={() => setHovered(item.key)}
            onMouseLeave={() => setHovered(null)}
            aria-label={`Show ${item.region} partners`}
            title={`${item.region} — ${item.members.length} partners`}
            className={`absolute flex h-9 w-9 -translate-x-1/2 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full transition-all duration-300 hover:scale-125 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#DA2128] focus-visible:ring-offset-2 ${
              isActive ? "z-30" : "z-20"
            }`}
            style={{ left: item.marker.x, top: item.marker.y }}
          >
            {/* ripple rings */}
            <span
              className={`absolute rounded-full ${
                isActive ? "h-9 w-9 bg-[#DA2128]/25" : "h-6 w-6 bg-[#F59C00]/20"
              } assoc-ripple`}
              style={{ animationDelay: `${i * 0.25}s` }}
            />
            {isActive && (
              <span className="absolute h-7 w-7 animate-ping rounded-full bg-[#F59C00]/40" />
            )}

            {/* gradient location dot */}
            <span
              className={`relative rounded-full border-[2px] border-white shadow-[0_6px_14px_rgba(119,61,0,0.35)] transition-all duration-300 ${
                isActive
                  ? "h-[17px] w-[17px]"
                  : isHover
                  ? "h-[15px] w-[15px]"
                  : "h-[13px] w-[13px]"
              }`}
              style={{
                backgroundImage:
                  "radial-gradient(circle at 32% 28%, #FFD277 0%, #F59C00 38%, #DB6400 66%, #DA2128 100%)",
              }}
            >
              <span className="absolute left-1/2 top-[18%] h-[3px] w-[4px] -translate-x-1/2 rounded-full bg-white/70" />
            </span>

            {/* hover tooltip */}
            {isHover && !isActive && (
              <span className="pointer-events-none absolute bottom-full left-1/2 mb-1.5 -translate-x-1/2 whitespace-nowrap rounded-[5px] bg-[#1a1a2e]/90 px-2 py-1 text-[9px] font-bold uppercase tracking-wide text-white shadow-lg">
                {item.region} · {item.members.length}
              </span>
            )}
          </button>
        );
      })}

      {/* HQ chip */}
      <div
        className="pointer-events-none absolute z-20 whitespace-nowrap rounded-[5px] border border-white/40 bg-[#DA2128] px-[8px] py-[3px] text-[9px] font-extrabold uppercase tracking-wide text-white shadow-[0_8px_16px_rgba(126,0,0,0.22)]"
        style={{ left: HQ_MARKER.x, top: HQ_MARKER.y, transform: "translate(-50%, 14px)" }}
      >
        India HQ
      </div>

      {/* selected region label chip */}
      <div
        className="pointer-events-none absolute z-40 whitespace-nowrap rounded-[6px] bg-gradient-to-r from-[#F59C00] to-[#DB6400] px-[11px] py-[5px] text-[11px] font-extrabold uppercase leading-none tracking-wide text-white shadow-[0_10px_20px_rgba(126,56,0,0.28)] transition-all duration-500 ease-out"
        style={{
          left: selected.marker.x,
          top: selected.marker.y,
          transform: "translate(-50%, calc(-100% - 16px))",
        }}
      >
        {selected.region.toUpperCase()}
        <span className="absolute left-1/2 top-full h-0 w-0 -translate-x-1/2 border-x-[5px] border-t-[5px] border-x-transparent border-t-[#DB6400]" />
      </div>

      {/* legend */}
      <div className="pointer-events-none absolute bottom-3 left-4 z-30 flex items-center gap-4 rounded-full bg-white/80 px-3.5 py-1.5 text-[10px] font-semibold text-[#6a6a7a] shadow-sm backdrop-blur-sm">
        <span className="flex items-center gap-1.5">
          <span className="h-2 w-2 rounded-full bg-[#DA2128]" /> Headquarters
        </span>
        <span className="flex items-center gap-1.5">
          <span className="h-2 w-2 rounded-full bg-[#F59C00]" /> Partner Region
        </span>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------------
// RegionCard — region details + clickable region buttons + member list
// ---------------------------------------------------------------------------

function RegionCard({ region, regions, onSelect }) {
  return (
    <div className="relative flex w-full flex-col overflow-hidden rounded-[24px] bg-gradient-to-br from-[#fb9a08] via-[#e97900] to-[#cb4a00] p-6 text-white shadow-[0_24px_60px_rgba(116,35,0,0.22)]">
      <div className="pointer-events-none absolute -right-12 -top-12 h-44 w-44 rounded-full bg-white/10 blur-2xl" />
      <div className="pointer-events-none absolute -bottom-14 -left-10 h-40 w-40 rounded-full bg-[#DA2128]/25 blur-2xl" />

      {/* Clickable region buttons */}
      <div className="relative z-10 mb-5 flex flex-wrap gap-1.5">
        {regions.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => onSelect(item)}
            className={`rounded-full px-3 py-1.5 text-[11px] font-bold transition-all duration-300 ${
              item.key === region.key
                ? "scale-105 bg-white text-[#c67800] shadow-md"
                : "bg-white/20 text-white hover:bg-white/35"
            }`}
          >
            {item.region}
          </button>
        ))}
      </div>

      {/* Header */}
      <div className="relative z-10 mb-4 border-b border-white/25 pb-4">
        <div className="mb-1 flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.16em] text-white/70">
          <Globe2 className="h-3 w-3" /> Partner Region
        </div>
        <h4 className="font-['Cormorant_Garamond'] text-3xl font-semibold leading-none tracking-tight">
          {region.region}
        </h4>
        <div className="mt-2 inline-flex items-center gap-1.5 rounded-full bg-white/20 px-2.5 py-1 text-[10px] font-semibold">
          <HeartHandshake className="h-3 w-3" /> {region.members.length} Partner
          {region.members.length > 1 ? "s" : ""}
        </div>
        <p className="mt-3 text-[12px] leading-[1.5] text-white/85">{region.blurb}</p>
      </div>

      {/* Member list */}
      <div className="relative z-10">
        <div className="mb-2 flex items-center gap-1.5 text-[9.5px] font-bold uppercase tracking-[0.16em] text-white/60">
          <Building2 className="h-3 w-3" /> Chambers & Associations
        </div>

        <ul className="assoc-scroll max-h-[300px] space-y-1.5 overflow-y-auto pr-1.5">
          {region.members.map((member) => (
            <li key={member}>
              <a
                href={mapSearchUrl(member)}
                target="_blank"
                rel="noreferrer"
                className="group flex items-start gap-2 rounded-xl bg-white/10 px-3 py-2 text-[12px] leading-[1.4] outline-none transition-all duration-300 hover:bg-white/25 focus-visible:ring-2 focus-visible:ring-white/80"
              >
                <span className="mt-[5px] h-1.5 w-1.5 flex-shrink-0 rounded-full bg-white/70 transition-colors group-hover:bg-white" />
                <span className="min-w-0 flex-1 break-words group-hover:underline">{member}</span>
                <ArrowUpRight className="mt-[2px] h-3.5 w-3.5 flex-shrink-0 opacity-0 transition-opacity group-hover:opacity-80" />
              </a>
            </li>
          ))}
        </ul>
      </div>

      <a
        href="#"
        className="relative z-10 mt-5 block rounded-full bg-white py-3 text-center text-[13px] font-bold text-[#c64a00] shadow-lg transition-transform hover:scale-[1.02]"
      >
        Connect with {region.region} →
      </a>
    </div>
  );
}

// ---------------------------------------------------------------------------
// Main Component
// ---------------------------------------------------------------------------

export default function GlobalPresence() {
  const [selectedKey, setSelectedKey] = useState("asia");

  const selectedRegion = useMemo(
    () => REGIONS.find((item) => item.key === selectedKey) || REGIONS[0],
    [selectedKey]
  );

  const handleSelect = (item) => setSelectedKey(item.key);

  const pad = (n) => String(n).padStart(2, "0");

  return (
    <div className="rounded-[28px] border border-[#FEF7F4] bg-white p-6 shadow-xl shadow-black/[0.04] md:p-10">
      <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-[#DA2128]/10 px-3.5 py-1.5 text-xs font-bold uppercase tracking-wider text-[#DA2128]">
            <MapPin className="h-3.5 w-3.5" /> Global Footprint
          </div>
          {/* <h3 className="font-['Cormorant_Garamond'] text-4xl font-semibold tracking-tight text-[#1a1a2e] md:text-5xl">
            ASSOCHAM{" "}
            <span className="italic font-normal text-[#DB6400]">International Partners</span>
          </h3> */}
          <p className="mt-3 max-w-xl text-[#6a6a7a]">
            Select a region on the map to view our partner chambers, federations and business
            councils in that part of the world.
          </p>
        </div>
        <div className="flex gap-6">
          <div>
            <div className="font-['Outfit'] text-3xl font-bold text-[#DA2128]">
              {pad(TOTAL_PARTNERS)}
            </div>
            <div className="text-xs font-semibold uppercase tracking-wide text-[#9a9aab]">
              Partner Bodies
            </div>
          </div>
          <div>
            <div className="font-['Outfit'] text-3xl font-bold text-[#DB6400]">
              {pad(REGIONS.length)}
            </div>
            <div className="text-xs font-semibold uppercase tracking-wide text-[#9a9aab]">
              Regions
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col items-stretch gap-6 lg:flex-row lg:items-start">
        <div className="min-w-0 flex-1">
          <WorldMap selected={selectedRegion} onSelect={handleSelect} />

          {/* quick region strip under the map */}
          <div className="mt-4 flex flex-wrap gap-2">
            {REGIONS.map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => handleSelect(item)}
                className={`flex items-center gap-1.5 rounded-full border px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-wide transition-all duration-300 ${
                  item.key === selectedRegion.key
                    ? "scale-105 border-transparent bg-gradient-to-r from-[#F59C00] to-[#DB6400] text-white shadow-md"
                    : "border-[#f0e4da] bg-white text-[#6a6a7a] hover:border-[#DB6400]/40 hover:text-[#DB6400]"
                }`}
              >
                <Layers className="h-3 w-3" />
                {item.region}
                <span className="opacity-70">{item.members.length}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="w-full lg:w-[340px] lg:flex-shrink-0">
          <RegionCard region={selectedRegion} regions={REGIONS} onSelect={handleSelect} />
        </div>
      </div>
    </div>
  );
}
